(function () {
  // Product gallery: swipeable track, arrows, dots and thumbnails stay in sync
  var track = document.getElementById('rfTrack');
  if (track) {
    var slides = [].slice.call(track.children);
    var dots = [].slice.call(document.querySelectorAll('.gal-dots span'));
    var thumbs = [].slice.call(document.querySelectorAll('.rf-thumb'));
    var cur = 0;
    var mark = function (i) {
      cur = i;
      dots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
      thumbs.forEach(function (x, k) { x.classList.toggle('on', k === i); x.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    };
    var go = function (i) {
      i = (i + slides.length) % slides.length;
      var rtl = getComputedStyle(track).direction === 'rtl';
      track.scrollTo({ left: (rtl ? -1 : 1) * i * track.clientWidth, behavior: 'smooth' });
      mark(i);
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) mark(slides.indexOf(e.target)); });
      }, { root: track, threshold: 0.6 });
      slides.forEach(function (s) { io.observe(s); });
    }
    document.querySelectorAll('[data-gal]').forEach(function (b) {
      b.addEventListener('click', function () { go(cur + parseInt(b.getAttribute('data-gal'), 10)); });
    });
    thumbs.forEach(function (x) { x.addEventListener('click', function () { go(parseInt(x.getAttribute('data-i'), 10)); }); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur + 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(cur - 1); }
    });
  }

  // Buy box: colour + pack pick the matching variant
  var form = document.getElementById('rfForm');
  if (form) {
    var variants = JSON.parse(document.getElementById('rfVariants').textContent);
    var state = { color: form.getAttribute('data-color'), pack: form.getAttribute('data-pack') };
    var idInput = document.getElementById('rfVariant');
    var total = document.getElementById('rfTotal');
    var money = function (cents) { return '₪' + Math.round(cents / 100); };
    var sync = function () {
      var v = variants.find(function (x) { return x.option1 === state.color && x.option2 === state.pack; });
      if (!v) return;
      idInput.value = v.id;
      total.textContent = money(v.price);
      form.querySelectorAll('[data-color-pick]').forEach(function (b) {
        var on = b.getAttribute('data-color-pick') === state.color;
        b.classList.toggle('on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      form.querySelectorAll('[data-pack-pick]').forEach(function (b) {
        var on = b.getAttribute('data-pack-pick') === state.pack;
        b.classList.toggle('on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    };
    form.querySelectorAll('[data-color-pick]').forEach(function (b) {
      b.addEventListener('click', function () { state.color = b.getAttribute('data-color-pick'); sync(); });
    });
    form.querySelectorAll('[data-pack-pick]').forEach(function (b) {
      b.addEventListener('click', function () { state.pack = b.getAttribute('data-pack-pick'); sync(); });
    });
    sync();
  }

  // Mobile menu drawer
  var drw = document.getElementById('rfDrawer');
  if (drw) {
    var ov = document.querySelector('.drw-ov');
    var opener = document.querySelector('[data-menu-open]');
    var setOpen = function (on) {
      drw.classList.toggle('open', on);
      drw.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (ov) { if (on) { ov.hidden = false; requestAnimationFrame(function () { ov.classList.add('open'); }); } else { ov.classList.remove('open'); setTimeout(function () { ov.hidden = true; }, 250); } }
      document.body.classList.toggle('menu-open', on);
      if (opener) opener.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (on) { var x = drw.querySelector('.drw-x'); if (x) x.focus(); } else if (opener) { opener.focus(); }
    };
    if (opener) opener.addEventListener('click', function () { setOpen(true); });
    document.querySelectorAll('[data-menu-close]').forEach(function (b) { b.addEventListener('click', function () { setOpen(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drw.classList.contains('open')) setOpen(false); });
    drw.querySelectorAll('.drw-nav a').forEach(function (a) { a.addEventListener('click', function () { setOpen(false); }); });
  }

  // Side cart: opens on add to cart and on the cart icon
  var cdr = document.getElementById('rfCart');
  if (cdr) {
    var cov = document.querySelector('.cdr-ov');
    var lastFocus = null;
    var setCart = function (on) {
      cdr.classList.toggle('open', on);
      cdr.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (cov) { if (on) { cov.hidden = false; requestAnimationFrame(function () { cov.classList.add('open'); }); } else { cov.classList.remove('open'); setTimeout(function () { cov.hidden = true; }, 250); } }
      document.body.classList.toggle('menu-open', on);
      if (on) { lastFocus = document.activeElement; var x = cdr.querySelector('[data-cart-close]'); if (x) x.focus(); } else if (lastFocus) { lastFocus.focus(); }
    };
    var paintBadge = function () {
      var wrap = cdr.querySelector('.cdr-wrap');
      var n = wrap ? parseInt(wrap.getAttribute('data-count'), 10) || 0 : 0;
      document.querySelectorAll('.cart-ic').forEach(function (a) {
        var b = a.querySelector('.cart-n');
        if (n > 0) { if (!b) { b = document.createElement('span'); b.className = 'cart-n'; a.appendChild(b); } b.textContent = n; }
        else if (b) { b.remove(); }
      });
    };
    var refresh = function () {
      return fetch('/?sections=rafivo-cart-drawer').then(function (r) { return r.json(); }).then(function (j) {
        var tmp = document.createElement('div');
        tmp.innerHTML = j['rafivo-cart-drawer'];
        var inner = tmp.querySelector('.cdr-wrap');
        var cur = cdr.querySelector('.cdr-wrap');
        if (inner && cur) cur.replaceWith(inner);
        paintBadge();
      });
    };
    var post = function (url, body) {
      return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); });
    };
    var busy = function (on) { cdr.classList.toggle('busy', on); };
    document.addEventListener('click', function (e) {
      var ic = e.target.closest('.cart-ic');
      if (ic) { e.preventDefault(); setCart(true); return; }
      if (e.target.closest('[data-cart-close]')) { setCart(false); return; }
      var up = e.target.closest('[data-upgrade]');
      if (up) {
        busy(true);
        post('/cart/change.js', { line: +up.getAttribute('data-line'), quantity: 0 })
          .then(function () { return post('/cart/add.js', { items: [{ id: +up.getAttribute('data-upgrade'), quantity: Math.max(1, +up.getAttribute('data-pairs')) }] }); })
          .then(refresh).catch(function () {}).then(function () { busy(false); });
        return;
      }
      var q = e.target.closest('.cdr [data-line][data-qty]');
      if (q) {
        busy(true);
        post('/cart/change.js', { line: +q.getAttribute('data-line'), quantity: Math.max(0, +q.getAttribute('data-qty')) })
          .then(refresh).catch(function () {}).then(function () { busy(false); });
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && cdr.classList.contains('open')) setCart(false); });
    var addForm = document.getElementById('rfForm');
    if (addForm) {
      addForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = addForm.querySelector('[type=submit]');
        if (btn) btn.disabled = true;
        post('/cart/add.js', { items: [{ id: +document.getElementById('rfVariant').value, quantity: 1 }] })
          .then(refresh).then(function () { setCart(true); })
          .catch(function () { addForm.submit(); })
          .then(function () { if (btn) btn.disabled = false; });
      });
    }
  }

  // Cookie banner, wired to Shopify's customer privacy API
  var bar = document.getElementById('rfCookies');
  if (!bar) return;
  var KEY = 'rfCookieChoice';
  var saved = null;
  try { saved = localStorage.getItem(KEY); } catch (e) {}
  var choice = { analytics: false, marketing: false };
  var apply = function () {
    var consent = { analytics: choice.analytics, marketing: choice.marketing, preferences: choice.analytics, sale_of_data: choice.marketing };
    var send = function () {
      if (window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.setTrackingConsent) {
        Shopify.customerPrivacy.setTrackingConsent(consent, function () {});
      }
    };
    if (window.Shopify && Shopify.loadFeatures) {
      Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { if (!err) send(); });
    } else { send(); }
    try { localStorage.setItem(KEY, JSON.stringify(choice)); } catch (e) {}
    bar.hidden = true;
  };
  if (saved) return;
  bar.hidden = false;
  var chips = bar.querySelectorAll('[data-ck]');
  var paint = function () {
    chips.forEach(function (c) {
      var on = choice[c.getAttribute('data-ck')];
      c.setAttribute('aria-pressed', on ? 'true' : 'false');
      c.style.cssText = on ? 'background:#1d4ed8;color:#fff;border:2px solid #1d4ed8' : 'background:transparent;color:#fff;border:2px solid #6f7585';
    });
  };
  paint();
  chips.forEach(function (c) {
    c.addEventListener('click', function () { var k = c.getAttribute('data-ck'); choice[k] = !choice[k]; paint(); });
  });
  bar.querySelectorAll('[data-ck-action]').forEach(function (b) {
    b.addEventListener('click', function () {
      var a = b.getAttribute('data-ck-action');
      if (a === 'all') { choice = { analytics: true, marketing: true }; apply(); }
      if (a === 'none') { choice = { analytics: false, marketing: false }; apply(); }
      if (a === 'save') { apply(); }
      if (a === 'settings') {
        document.getElementById('rfCkSettings').hidden = false;
        b.hidden = true;
        bar.querySelector('[data-ck-action="save"]').hidden = false;
      }
    });
  });
})();
